var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"listingPage"},[_c('Catalog',{attrs:{"allFilters":""}}),_c('Contact'),_c('DrawLine',{staticClass:"_y _1"}),_c('DrawLine',{staticClass:"_x _fullWidth _2"}),_c('DrawLine',{staticClass:"_x _fullWidth _3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }